<template>
    <b-modal id="fileModal" 
        static
        size="huge"
        :title="$t('project.files')" 
        hide-footer 
        @show="shownModal()"
        @hidden="clearForm();">
        <b-overlay :show="showOverlay" rounded="sm">
            <b-form v-on:submit.prevent="createFile">
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="4">
                        <label for="fType">{{ $t('fForm.fType') }}</label>
                        <select required id="fType" 
                            class="form-control" 
                            v-model="fForm.fType">
                            <option value="">
                                {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                            </option>
                            <option v-for="con in fTypes" :value="con.key">
                                {{con.value}}
                            </option>
                        </select>
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="fKm">{{ $t('fForm.km') }}</label>
                        <input type="number" id="fkm" 
                            class="form-control" 
                            v-model.number="fForm.fKm" min="1">
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="fPrice">{{ $t('fForm.price') }}</label>
                        <input type="number" id="fPrice" 
                            class="form-control" 
                            v-model.number="fForm.fPrice" min="0">
                    </b-col>
                    
                </b-form-row>
                <b-form-row class="mb-3" v-if="fForm.fType=='contract'">
                    <b-col sm="auto" lg="12">
                        <label for="endDate">{{ $t('fForm.endDate') }}</label>
                        <input class="form-control" required id="endDate" v-model="fForm.endDate" type="date">
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="12">
                        <label for="desc">{{ $t('fForm.desc') }}</label>
                        <textarea  required id="desc" 
                            class="form-control" 
                            v-model="fForm.fDesc"></textarea>
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="12">
                        <label for="fFile">{{ $t('fForm.fFile') }}</label>
                        <b-form-file
                            id="fFile"
                            v-model="fForm.file1"
                            :state="Boolean(fForm.file1)"
                            placeholder="Загрузите файл ..."
                            drop-placeholder=""
                        ></b-form-file>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col lg="12">
                        <b-row class="pt-2">
                            <b-col lg="6">
                                <b-button size="sm" block variant="primary" @click="closeModal()" class="mr-2" >{{$t("hForm.back")}}</b-button>
                            </b-col>
                            <b-col lg="6">
                                <b-button size="sm" block variant="success" type="submit" >{{$t("fForm.addFile")}}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-overlay>
        <b-row>
            <b-col lg="12">
                <ProjectFileList :pId="pId" ref="childRef"></ProjectFileList>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeader} from "@/config/config";
    import vue from 'vue';
    import ProjectFileList from '@/components/dag/ProjectFileList';
    export default {
        name:"BudgetHistory",
        props:["pId"],
        components:{
            ProjectFileList
        },
        data(){
            return {
                fForm:{
                    fType:"",
                    fId:0,
                    fDesc:"",
                    fPrice:0,
                    fKm:0,
                    endDate:"",
                    file1:null,
                    pId:this.pId,

                },
                // '', 'Заключение госЭкспернтизы', 'Акт','Гарантинное письмо'
                fTypes:[
                    {
                        key:"contract",
                        value:"Договор"
                    },
                    {
                        key:"exam",
                        value:"Заключение госэкспернтизы"
                    },
                    {
                        key:"act",
                        value:"Акт выполненных работ"
                    },
                    {
                        key:"gurantee",
                        value:"Гарантинное письмо"
                    }
                   
                ],
                showOverlay:false,
            }
        },
        methods:{
            createFile(){
                this.fForm.pId=this.pId
                if(this.fForm.file1!=null && this.fForm.pId>0){
                    
                    this.showOverlay=true;
                    let formData = new FormData();
                    formData.append("pFile",this.fForm.file1);
                    formData.append("jsonData",JSON.stringify(this.fForm));
                    axios.post(apiDomain+'/p/createfile',formData,{headers:getMultipartHeader()})
                    .then(()=>{
                        this.showOverlay=false
                        this.$bvToast.toast(vue.i18n.translate("system.successMsg"), {
                            toaster:'b-toaster-top-center',
                            variant: "success",
                            autoHideDelay: 3000
                        });
                        this.$refs.childRef.sysChange();
                        this.clearForm();
                    })
                    .catch(error => {
                        alert(error.message);
                        this.showOverlay=false
                    })
                    
                }else{
                    this.showOverlay=false
                    this.$bvToast.toast(vue.i18n.translate("system.noFile"), {
                        toaster:'b-toaster-top-center',
                        variant: "danger",
                        autoHideDelay: 3000
                    })
                    return 
                }
            },
            closeModal(){
                this.clearForm();
                this.$bvModal.hide("fileModal");
            },
            shownModal(){
                this.$refs.childRef.sysChange();
            },
            
            clearForm(){
                this.fForm={
                    fType:"",
                    fId:0,
                    fDesc:"",
                    fPrice:0,
                    fKm:0,
                    endDate:"",
                    file1:null,
                    pId:this.pId,
                };
                
            }
        },
        created(){
            
        }
    }
</script>
<style >
  .modal .modal-huge {
    max-width: 80%;
  }
</style>